<script>
  import { subscribe } from '../../helpers/subscribe'
  import Modal from '../components/Modal.svelte'
  import { FormHandler } from '../helpers/formHandler'
  import Container from '../components/Container.svelte'
  import Block from '../components/Block.svelte'
	import Button from '../components/Button.svelte'
  import Placeholder from '../components/Placeholder.svelte'
  import Input from '../components/Input.svelte'

  export let authStore, modalHandler, modalDataStore, snackBarHandler, formCallback, formHandler, formNode
  export let spacingModal = 36

  let dataLoaded = {
    data: {
      loaded: true
    }
  }
  export let loaderStore = subscribe()
  loaderStore.set(dataLoaded.data)

  $: if ($authStore.user) {
    formHandler = new FormHandler(formCallback, loaderStore, dataLoaded, snackBarHandler)
  }

  // let deleteData = {
  //   data: {
  //     delete: false
  //   }
  // }
  // export let deleteStore = subscribe()
  // deleteStore.set(deleteData.data)
  // function delete_item() {
  //   if (window.confirm(`Tem certeza que deseja excluir o ítem?`)) {
  //     deleteStore.set({delete: $modalDataStore.currentPage})
  //     setTimeout(function() {
  //       formHandler.submit(formNode)
  //     }, 100);
  //   }
  // }
  export let moverPara, btnMover
  switch ($modalDataStore.currentPage) {
    case 'inscritos':
      moverPara = 'desistencia'
      btnMover = 'Desistência'
      break;
    case 'lista-de-espera':
      moverPara = 'inscritos'
      btnMover = 'Inscritos'
      break;
  }
</script>

<Modal
  columns=2
  title={$modalDataStore.title}
  subtitle={$modalDataStore.subtitle}
  spacingContainer={spacingModal}
  handler={modalHandler}
>
  <form
    on:submit|preventDefault={formHandler.submit.bind(formHandler, this)}
    bind:this={formNode}
  >
    {#if $modalDataStore.id}
      <input type="hidden" name="id" value={$modalDataStore.id}>
      <input type="hidden" name="created_date" value={$modalDataStore.created_date}>
      <!-- <input type="hidden" name="delete" value={$deleteStore.delete}> -->
    {/if}

    <Container
      spacing={spacingModal}
      style="align-items: end;"
    >
      <Block
        l=50
      >
        <Input
          id="nome"
          label="Nome"
          type="text"
          name="nome"
          required={false}
          value={$modalDataStore.nome}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="instagram"
          label="Instagram"
          type="text"
          name="instagram"
          required={false}
          value={$modalDataStore.instagram}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="email"
          label="Email"
          type="text"
          name="email"
          required={false}
          value={$modalDataStore.email}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="celular"
          label="Celular"
          type="text"
          name="celular"
          required={false}
          value={$modalDataStore.celular}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <input type="hidden" name="nascimento" value={$modalDataStore.nascimentoRaw}>
        <Input
          id="nascimento"
          label="Data de Nascimento"
          type="text"
          name={false}
          required={false}
          value={$modalDataStore.nascimentoDisplay}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="cep"
          label="CEP"
          type="text"
          name="cep"
          required={false}
          value={$modalDataStore.cep}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="endereco"
          label="Endereço"
          type="text"
          name="endereco"
          required={false}
          value={$modalDataStore.endereco}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="numero"
          label="Nº"
          type="text"
          name="numero"
          required={false}
          value={$modalDataStore.numero}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="complemento"
          label="Complemento"
          type="text"
          name="complemento"
          required={false}
          value={$modalDataStore.complemento}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="bairro"
          label="Bairro"
          type="text"
          name="bairro"
          required={false}
          value={$modalDataStore.bairro}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="estado"
          label="Estado"
          type="text"
          name="estado"
          required={false}
          value={$modalDataStore.estado}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=50
      >
        <Input
          id="cidade"
          label="Cidade"
          type="text"
          name="cidade"
          required={false}
          value={$modalDataStore.cidade}
          readonly={$modalDataStore.id ? 'readonly' : null}
        />
      </Block>
      <Block
        l=100
      >
        Autoriza a coleta e o armazenamento de dados pessoais: 
        <span style="font-weight: 500; font-size: 18px;">
          {$modalDataStore.autorizo_coleta_dados == '1' ? 'Sim' : 'Não'}
        </span>
        <input type="hidden" name="autorizo_coleta_dados" value={$modalDataStore.autorizo_coleta_dados}>
        <input type="hidden" name="aceito_regulamento_e_politica" value={$modalDataStore.aceito_regulamento_e_politica}>
      </Block>
    </Container>
    <Container
      spacing={spacingModal}
      style="align-items: center; justify-content: center; margin-top: 24px;"
    >
      {#if
        $modalDataStore.id &&
        ['lista-de-espera', 'inscritos'].includes($modalDataStore.currentPage)
      }
        <input type="hidden" name="mover_para" value={moverPara}>
        <Block
          l=100
          style="display: flex; justify-content: center;"
        >
          {#if !$loaderStore.loaded}
            <Placeholder
              style="width: 293px; height: 40px;"
            />
          {:else}
            <Button
              text={`Mover para lista de ${btnMover}`}
              type="submit"
              classes="primary"
            />
          {/if}
        </Block>
      {/if}
      <Block>
        <Button
          text={$modalDataStore.id ? 'Fechar' : 'Cancelar'}
          type="button"
          classes="secondary"
          onclick={modalHandler.action.bind(modalHandler)}
        />
      </Block>
      {#if !$modalDataStore.id}
        <Block
          style="padding-left: 18px;"
        >
          {#if !$loaderStore.loaded}
            <Placeholder
              style="width: 96px; height: 40px;"
            />
          {:else}
            <Button
              text="Salvar"
              type="submit"
              classes="primary"
            />
          {/if}
        </Block>
      {/if}
      <!-- {#if $modalDataStore.id}
        <Block
          l=100
          style="display: flex; justify-content: center;"
        >
          <Button
            text="Excluir"
            type="button"
            classes="small secondary borderless"
            style="opacity: .75;"
            onclick={delete_item}
          />
        </Block>
      {/if} -->
    </Container>
  </form>
</Modal>